import { Metrohoudai } from '@linktivity/link-connect';
import config from '../config';

const orderApi = new Metrohoudai.OrderApi(config);

export default orderApi;
